import { define, html } from "hybrids";

export default define({
  tag: "v-broadcast-divider",
  render: () => html`<slot></slot>`.css`
    :host {
      display: block;
      margin: var(--v-broadcast-layout-spacing) 0;
      height: 1px;
      background: rgba(255, 255, 255, 0.1);
    }

    :host(:last-child) {
      display: none;
    }
  `,
});
